import { api, API_BASE } from "@/api/client";
import type { SyncChangesResponse } from "@/api/types";

export const getChanges = (cursor = 0, limit = 100) => api.get<SyncChangesResponse>("/v1/sync/changes", { cursor, limit });

export const createSSEConnection = (accessToken: string) => {
  const url = new URL("/v1/sync/events", API_BASE);
  url.searchParams.set("access_token", accessToken);
  return new EventSource(url.toString(), { withCredentials: true });
};
